
export const Loader = () => {
  return (
    <div className="page-content">
        <div className="loader-wrapper">
            <div className="loader"></div>
        </div>
    </div>
  )
}

export default Loader